const l = "styles-module__modal_gallery___cCndt", _ = "styles-module__modal_gallery_overlay___h3wvM", o = "styles-module__modal_gallery_container___pSMHL", e = "styles-module__modal_gallery_image_container___x06wx", a = "styles-module__modal_gallery_image___tZjhp", m = "styles-module__modal_gallery_message___uZaqN", r = "styles-module__modal_gallery_image_counter___NxTod", d = "styles-module__modal_gallery_navigation___3p-TT", s = "styles-module__modal_gallery_navigation_disabled___CMYJN", t = "styles-module__modal_gallery_close___h00-t", g = "styles-module__modal_gallery_mobile_footer___SYdTO", y = "styles-module__no_scroll___UoWWq", n = "styles-module__modal_gallery_mobile_footer_counter___BhwRf", i = {
  modal_gallery: l,
  modal_gallery_overlay: _,
  modal_gallery_container: o,
  modal_gallery_image_container: e,
  modal_gallery_image: a,
  modal_gallery_message: m,
  modal_gallery_image_counter: r,
  modal_gallery_navigation: d,
  modal_gallery_navigation_disabled: s,
  modal_gallery_close: t,
  modal_gallery_mobile_footer: g,
  no_scroll: y,
  modal_gallery_mobile_footer_counter: n
};
export {
  i as default,
  l as modal_gallery,
  t as modal_gallery_close,
  o as modal_gallery_container,
  a as modal_gallery_image,
  e as modal_gallery_image_container,
  r as modal_gallery_image_counter,
  m as modal_gallery_message,
  g as modal_gallery_mobile_footer,
  n as modal_gallery_mobile_footer_counter,
  d as modal_gallery_navigation,
  s as modal_gallery_navigation_disabled,
  _ as modal_gallery_overlay,
  y as no_scroll
};
